export default {
	inProcessDev: `Strona w budowie! <br/> Wkrótce będziesz mógł korzystać ze wszystkich jego funkcji. <br/> <strong> Dziękujemy za zrozumienie </strong>`,
}